export default __webpack_public_path__ + "static/media/gallery-wip-control-box_01.9b2efab8.jpg";